import * as React from 'react';
import { SyntheticEvent } from 'react';
import { ChangeEvent } from 'react';
import magnifyingGlass from '../img/magnifying-glass.svg';
import './Search.css';

interface Props {
    onSearch: (value: string) => void;
    value: string;
}

class Search extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <div className="orders-toolbar-search">
                <form onSubmit={this.onSubmit}>
                    <input
                        className="orders-toolbar-search-input"
                        type="text"
                        name="search"
                        placeholder="Search"
                        value={this.props.value}
                        onChange={this.handleInputChange}
                    />
                    {this.props.value.length === 0 && <img className="orders-toolbar-search-glass" src={magnifyingGlass} />}
                </form>
                {this.props.value.length > 0 && (
                    <button className="orders-toolbar-search-clear" onClick={this.clearSearch}>
                        x
                    </button>
                )}
            </div>
        );
    }

    private handleInputChange = (event: ChangeEvent<HTMLInputElement>): void => {
        this.props.onSearch(event.target.value);
    };

    private clearSearch = (): void => this.props.onSearch('');

    private onSubmit = (event: SyntheticEvent): void => {
        event.preventDefault();
    };
}

export default Search;



// WEBPACK FOOTER //
// ./src/view/search/Search.tsx